const setTokenWithExpiry = (token: string, tokenExpiryTime?: string) => {
  if (tokenExpiryTime) {
    const expiry = new Date(tokenExpiryTime.replace(/-/g, '/')).getTime();
    window.localStorage.setItem('BLOX_USER_TOKEN_EXPIRY', JSON.stringify(expiry));
  }
  window.localStorage.setItem('BLOX_USER_TOKEN', token);
};

export default setTokenWithExpiry;
